import { Routes, Route, Navigate } from 'react-router-dom';
import { useAuth } from './context/AuthContext.jsx';

import Nav from './components/Nav.jsx';
import Footer from './components/Footer.jsx';

import Landing from './pages/Landing.jsx';
import SignIn from './pages/SignIn.jsx';
import SignUp from './pages/SignUp.jsx';
import Confirm from './pages/Confirm.jsx';
import ForgotPassword from './pages/ForgotPassword.jsx';
import ResetPassword from './pages/ResetPassword.jsx';
import Dashboard from './pages/Dashboard.jsx';
import ItemEditor from './pages/ItemEditor.jsx';
import ItemDetail from './pages/ItemDetail.jsx';
import Claims from './pages/Claims.jsx';
import Settings from './pages/Settings.jsx';
import PrintQR from './pages/PrintQR.jsx';
import PrintHandle from './pages/PrintHandle.jsx';
import Inbox from './pages/Inbox.jsx';

function Private({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <Loading />;
  if (!user) return <Navigate to="/signin" replace />;
  return children;
}

function Loading() {
  return (
    <div className="app-loading">
      <em>Loading…</em>
    </div>
  );
}

export default function App() {
  return (
    <>
      <Nav />
      <main className="container app-main">
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/signin" element={<SignIn />} />
          <Route path="/signup" element={<SignUp />} />
          <Route path="/confirm" element={<Confirm />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />

          <Route path="/dashboard" element={<Private><Dashboard /></Private>} />
          <Route path="/items/new" element={<Private><ItemEditor /></Private>} />
          <Route path="/items/:itemId" element={<Private><ItemDetail /></Private>} />
          <Route path="/items/:itemId/edit" element={<Private><ItemEditor /></Private>} />
          <Route path="/items/:itemId/claims" element={<Private><Claims /></Private>} />
          <Route path="/reports" element={<Navigate to="/inbox" replace />} />
          <Route path="/inbox" element={<Inbox />} />
          <Route path="/reports" element={<Navigate to="/inbox" replace />} />
          <Route path="/settings" element={<Private><Settings /></Private>} />
          <Route path="/items/:itemId/print" element={<PrintQR />} />
          <Route path="/settings/handle/print" element={<PrintHandle />} />

          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </main>
      <Footer />
    </>
  );
}
